module.exports = __webpack_public_path__ + "static/media/phonepe-icon.1f1ff9fb.png";